<template>
  <div class="help-edit-history-box">
    <p class="tip">
      <span>被 {{dataset.created_user ? dataset.created_user.realname : ''}} 创建于 {{dataset.create_time ? dataset.create_time.replace(/-/g, '/') : ''}}</span>，
      <span>被 {{dataset.updated_user ? dataset.updated_user.realname : ''}} 最后更新于 {{dataset.update_time ? dataset.update_time.replace(/-/g, '/') : ''}}</span>
    </p>
    <el-popover
      placement="bottom"
      width="400"
      popper-class="help-edit-history-popover"
      ref="popover"
      v-if="dataset.released_records_count > 0"
      trigger="click">
      <div class="list" v-infinite-scroll="loadNext" :infinite-scroll-distance="20" :infinite-scroll-immediate="false">
        <div class="item" v-for="item in list" :key="item.id">
          <toolTip :title="`${item.title}-${item.released_time ? item.released_time.replace(/-/g, '/') : ''}`">
            <span>{{item.title}}-{{item.released_time ? item.released_time.replace(/-/g, '/') : ''}}</span>
          </toolTip>
          <p class="btn">
            <span class="letterHover" style="margin-right: 20px;" @click="reviews(item)">查看</span>
            <span class="letterHover" @click="edit(item)">编辑</span>
          </p>
        </div>
        <div class="loading-box" v-if="loading">
          <i class="el-icon-loading"></i>
        </div>
      </div>
       <span slot="reference" class="letterHover btn" @click="check">查看发布记录</span>
    </el-popover>
  </div>
</template>
<script>
import api from '@/services/api/help/help'
export default {
  props: {
    dataset: {
      type: Object,
      default: () => {}
    }
  },
  watch: {
    'dataset.id': {
      handler() {
        this.init()
      },
      deep: true,
      immediate: true
    }
  },
  data() {
    return {
      list: [],
      page: 1,
      per_page: 10,
      loading: false,
      finish: false
    }
  },
  methods: {
     init() {
      if(!this.dataset.id) return
      this.page = 1
      this.per_page = 10
      this.finish = false
      this.loading = false
      this.list = []
    },
    async load() {
      if(this.loading || this.finish) return
      this.loading = true
      let params = {
        per_page: this.per_page,
        page: this.page,
        document_draft_id: this.dataset.id,
        record_type: 3
      }
      let result = await api.documentDraftRecordsIndex(params)
      this.list.push(...result.data)
      this.loading = false
      if(result.data.length === 0) {
        this.finish = true
      }
    },
    check() {
      this.load()
    },
    loadNext() {
      this.page = this.page + 1
      this.load()
    },
    reviews(item) {
      this.$emit('reviews', item)
    },
    async edit(item) {
      await this.$wfAlert('', '是否编辑','编辑将会回到历史版本，当前内容将会被覆盖，确认编辑？')
      this.$refs.popover.doClose()
      this.$emit('edit', item)
    }
  }
}
</script>
<style lang="scss">
.help-edit-history-popover {
  .list {
    display: flex;
    flex-direction: column;
    padding: 8px 0;
    max-height: 400px;
    overflow-x: hidden;
    overflow: overlay;
    .item {
      display: flex;
      align-items: center;
      height: 40px;
      padding: 0 16px;
      justify-content: space-between;
      flex-shrink: 0;
      .tool-tip {
        width: 0;
        flex: 1;
      }
      &:hover {
        background-color: rgba(32, 32, 32, 0.04);
        .btn {
          visibility: visible;
        }
      }
      &:active {
        background-color: rgba(32, 32, 32, 0.08);
      }
    }
    .btn {
      visibility: hidden;
    }
    .loading-box {
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      i {
        margin-right: 8px;
        font-size: 14px;
      }
    }
  }
}
.help-edit-history-box {
  display: flex;
  align-items: center;
  height: 54px;
  background-color: rgba(32,32,32,0.04);
  padding: 0 21px;
  font-size: 14px;
  .tip {
    color: rgba(32, 32, 32, 0.6);
    font-weight: 400;
  }
  .btn {
    text-decoration: underline;
    margin-left: 20px;
  }
}
</style>
